   const images = [
        {
            "name": "Fresh Fruits",
            "images": "https://www.jiomart.com/images/category/36/thumb/0-36.png","id":"1","price":"100",

        },
        {
            "name": "Fresh Vegetables",
            "images": "https://www.jiomart.com/images/category/35/thumb/0-35.png","id":"2","price":"1002",
        },
        {
            "name": "Herbs & Seasonings",
            "images": "https://www.jiomart.com/images/category/37/thumb/0-37.png","id":"3","price":"1003",
        },
        {
            "name": "Dairy",
            "images": "https://www.jiomart.com/images/category/117/thumb/dairy-20200522.png","id":"4","price":"704",
        },
        {
            "name": "Toast & Khari",
            "images": "https://www.jiomart.com/images/category/46/thumb/0-46.png","id":"5","price":"005",
        },
        {
            "name": "Cakes & Muffins",
            "images": "https://www.jiomart.com/images/category/130/thumb/0-130.png","id":"6","price":"67",
        },
        {
            "name": "Breads and Buns",
            "images": "https://www.jiomart.com/images/category/240/thumb/breads-and-buns-20200522.png","id":"7","price":"1500",
        },
        {
            "name": "Bakery Snacks",
            "images": "https://www.jiomart.com/images/category/281/thumb/bakery-snacks-20200712.png","id":"8","price":"10",
        },
        {
            "name": "Atta, Flours & Sooji",
            "images": "https://www.jiomart.com/images/category/14/thumb/0-14.png","id":"9","price":"9",
        },
        {
            "name": "Dals & Pulses",
            "images": "https://www.jiomart.com/images/category/19/thumb/0-19.png","id":"11","price":"11",
        },
        {
            "name": "Rice & Rice Products",
            "images": "https://www.jiomart.com/images/category/16/thumb/0-16.png","id":"12","price":"12",
        },
        {
            "name": "Edible Oils",
            "images": "https://www.jiomart.com/images/category/18/thumb/0-18.png","id":"13","price":"13",
        },
        {
            "name": "Dry Fruits",
            "images": "https://www.jiomart.com/images/category/17/thumb/0-17.png","id":"14","price":"14",
        },
        {
            "name": "turmeric",
            "images": "https://www.jiomart.com/images/category/15/thumb/0-15.png","id":"15","price":"15",
        },
        {
            "name": "Madhur Tea Salt",
            "images": "https://www.jiomart.com/images/category/20/thumb/0-20.png","id":"16","price":"16",
        },
        {
            "name": "fortune",
            "images": "https://www.jiomart.com/images/category/72/thumb/soya-products-wheat-other-grains-20200522.png","id":"17","price":"100",
            "price":"200"

        },
        {
            "name": "Biscuits & Cookies",
            "images": "https://www.jiomart.com/images/category/44/thumb/0-44.png","id":"18","price":"100"
        },
        {
            "name": "Noodle, Pasta, Vermicelli",
            "images": "https://www.jiomart.com/images/category/191/thumb/noodle-pasta-vermicelli-20200603.png","id":"19","price":"100",
        },
        {
            "name": "Breakfast Cereals",
            "images": "https://www.jiomart.com/images/category/188/thumb/breakfast-cereals-20200603.png","id":"21","price":"100",
        },
        {
            "name": "Snacks & Namkeen",
            "images": "https://www.jiomart.com/images/category/135/thumb/0-135.png","id":"23","price":"100",
        },
        {
            "name": "Chocolates & Candies",
            "images": "https://www.jiomart.com/images/category/43/thumb/0-43.png","id":"24","price":"100",
        },
        {
            "name": "",
            "images": "https://www.jiomart.com/images/category/134/thumb/0-134.png","id":"25","price":"100",
        },
        {
            "name": "",
            "images": "https://www.jiomart.com/images/category/80/thumb/spreads-sauces-ketchup-20200603.png","id":"26","price":"100",
        },
        {
            "name": "Tea",
            "images": "https://www.jiomart.com/images/category/21/thumb/0-21.png","id":"27","price":"100",
        },
        {
            "name": "Coffee",
            "images": "https://www.jiomart.com/images/category/22/thumb/0-22.png","id":"28","price":"100",
            "id":{}
        },
        {
            "name": "Fruit juices",
            "images": "https://www.jiomart.com/images/category/25/thumb/0-25.png","id":"29","price":"100",
        },
        {
            "name": "Energy & Soft Drinks",
            "images": "https://www.jiomart.com/images/category/26/thumb/0-26.png","id":"31","price":"100",
        },
        {
            "name": "Health Drink & Supplement",
            "images": "https://www.jiomart.com/images/category/23/thumb/0-23.png","id":"32","price":"100",
        },
        {
            "name": "",
            "images": "https://www.jiomart.com/images/category/24/thumb/0-24.png","id":"33","price":"100",
        },
        {
            "name": "Hair Care",
            "images": "https://www.jiomart.com/images/category/31/thumb/0-31.png","id":"34","price":"100",
        },
        {
            "name": "Oral Care",
            "images": "https://www.jiomart.com/images/category/6/thumb/oral-care-20200603.png","id":"35","price":"100",
        },
        {
            "name": "Skin Care",
            "images": "https://www.jiomart.com/images/category/28/thumb/0-28.png","id":"36","price":"100",
        },
        {
            "name": "Bath & Hand Wash",
            "images": "https://www.jiomart.com/images/category/119/thumb/bath-hand-wash-20200712.png","id":"37","price":"100",
        },
        {
            "name": "Body Wash & Bathing Accessories",
            "images": "https://www.jiomart.com/images/category/8/thumb/body-wash-bathing-accessories-20200522.png","id":"38","price":"100",
        },
        {
            "name": "",
            "images": "https://www.jiomart.com/images/ category / 17 / thumb / feminine - hygiene - 20200605.png","id":"39","price":"100",
        },
        {
            "name": "",
            "images": "https://www.jiomart.com/images/category/110/thumb/0-110.png","id":"41","price":"100",
        },
        {
            "name": "",
            "images": "https://www.jiomart.com/images/category/112/thumb/0-112.png","id":"42","price":"100",
        },
        {
            "name": "",
            "images": "https://www.jiomart.com/images/category/111/thumb/0-111.png","id":"43","price":"100",
        },
        { "": "https://www.jiomart.com/images/category/67/thumb/makeup-20200522.png","id":"44","price":"100" },
        {
            "name": "Detergents",
            "images": "https://www.jiomart.com/images/category/32/thumb/0-32.png","id":"45","price":"100",
        },
        {
            "name": "Dishwash",
            "images": "https://www.jiomart.com/images/category/34/thumb/0-34.png","id":"46","price":"100",
        },
        {
            "name": "All Purpose Cleaners",
            "images": "https://www.jiomart.com/images/category/37/thumb/all-purpose-cleaners-20200603.png","id":"47","price":"100",
        },
        {
            "name": "Fresheners & Repellents",
            "images": "https://www.jiomart.com/images/category/44/thumb/fresheners-repellents-20200522.png","id":"48","price":"100",
        },
        {
            "name": "Mops, Brushes & Scrubs",
            "images": "https://www.jiomart.com/images/category/139/thumb/mops-brushes-scrubs-20200522.png","id":"49","price":"100",
        },
        {
            "name": "Battery",
            "images": "https://www.jiomart.com/images/category/162/thumb/electrical-20200520.png","id":"51","price":"100",
        },
        {
            "name": "",
            "images": "https://www.jiomart.com/images/category/167/thumb/disposables-20200522.png","id":"52","price":"100",
        },
        {
            "name": "",
            "images": "https://www.jiomart.com/images/category/169/thumb/pooja-needs-20200522.png","id":"53","price":"100",
        },
        {
            "name": "",
            "images": "https://www.jiomart.com/images/category/119/thumb/0-119.png","id":"54","price":"100",
        },
        {
            "name": "",
            "images": "https://www.jiomart.com/images/category/235/thumb/stationery-20200522.png","id":"55","price":"100",
        },
        {
            "name": "",
            "images": "https://www.jiomart.com/images/category/251/thumb/furnishing-20200608.png","id":"56","price":"1030",
        },
        {
            "name": "",
            "images": "https://www.jiomart.com/assets/smartweb/images/no-image.jpg","id":"56","price":"15434550"
        },
        {
            "name": "",
            "images": "https://www.jiomart.com/assets/smartweb/images/no-image.jpg","id":"57","price":"140"
        },
        {
            "name": "Baby Bath & Hygiene",
            "images": "https://www.jiomart.com/images/category/54/thumb/baby-bath-hygiene-20200522.png","id":"58","price":"1045",
        },
        {
            "name": "Diapers & Wipes",
            "images": "https://www.jiomart.com/images/category/39/thumb/0-39.png","id":"59","price":"100",
        },

    ]
    export default images
